import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import TenantInvoicePosition, { IGetTenantInvoicePositionDto } from "./TenantInvoicePosition"

export interface IGetTenantInvoicePositionsDto {
    entities: IGetTenantInvoicePositionDto[]
    links: IApiLink[]
}

export default class TenantInvoicePositions {
    entities: TenantInvoicePosition[]
    linkCreate?: IApiLink

    constructor(dto: IGetTenantInvoicePositionsDto) {
        this.entities = dto.entities?.map(e => new TenantInvoicePosition(e)) || []
        this.linkCreate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsInvoicePosition && lnk.rel === ApiLinkRel.new)
    }
}
